

















































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import DropdownWithLabelAndHint from '@/components/molecules/DropdownWithLabelAndHint.vue';
import TextFieldWithLabelAndHint from '@/components/molecules/TextFieldWithLabelAndHint.vue';
import { TaskMetadataArgItemForFront } from '@/types/type';

@Component({
  components: {
    TextFieldWithLabelAndHint,
    DropdownWithLabelAndHint,
  },
})
export default class TaskListItemDetail extends Vue {
  @Prop()
  private duplicateOutputPathExist!: boolean;

  @Prop()
  private textFields!: TaskMetadataArgItemForFront[];

  @Prop()
  private dropDownFields!: TaskMetadataArgItemForFront[];

  @Prop()
  private includeInDownload!: boolean;

  @Emit('updatedTaskListItemDetail')
  private updateTaskListItemDetail(data: { index: number; value: string }) {
    this.textFields[data.index].value = data.value;
    return {
      textFields: this.textFields,
    };
  }

  @Emit('updatedIncludeInDownload')
  private updateIncludeInDownload(value: boolean) {}

  private updateReplaceInFileName(order: number, value: boolean) {
    this.$emit('updatedReplaceInFileName', order, value);
  }

  private getKey(field: TaskMetadataArgItemForFront, index: number) {
    return `${index} ${field.labels[0].label} ${field.required}`;
  }

  private getInputType(field: TaskMetadataArgItemForFront) {
    if (field.isSecret) {
      return 'password';
    }
    return 'text';
  }
}
